import { Palette } from 'core/config';
import styled from 'styled-components';

export const StyledBannerContainer = styled.div`
    padding: 1rem;
    text-align: center;
    box-sizing: border-box;
    background-color: ${Palette.TAN};
`;

export const StyledBannerText = styled.p`
    font-family: 'SofiaPro-Regular';
    margin: 0;
    color: ${Palette.BLUE};
`;

export const StyledBannerLink = styled.a`
    color: ${Palette.BLUE};
`;
